import '@fontsource-variable/nunito';
import '@fontsource-variable/fraunces';
import './styles/tokens.css';
import './styles/app.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.tsx';
import { initData } from './data/index.ts';
import { refreshPushSubscription } from './data/push.ts';
import { noteAndroidApp } from './data/androidApp.ts';
import { retryPhotoUploads } from './data/photos.ts';

async function boot() {
  noteAndroidApp();
  const root = createRoot(document.getElementById('root')!);
  try {
    await initData();
    // Photos that couldn't reach the server earlier go up when they can.
    const retry = () => void retryPhotoUploads().catch(() => undefined);
    setTimeout(retry, 5_000);
    setInterval(retry, 5 * 60_000);
    window.addEventListener('online', retry);
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  } catch (err) {
    console.error(err);
    root.render(
      <div className="fatal">
        <h1>Arlo HQ couldn’t start</h1>
        <p>{String((err as Error).message ?? err)}</p>
        <button type="button" onClick={() => location.reload()}>
          Try again
        </button>
      </div>,
    );
  }
}

void boot();

// Ask the browser to keep this device's copy for good, rather than clearing it
// when space runs low (installed apps usually get this without asking).
void navigator.storage?.persist?.().catch(() => undefined);

// Offline support (requires HTTPS or localhost).
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('./sw.js')
      .then(() => refreshPushSubscription())
      .catch(() => undefined);
  });
}
